/**
 * @file Confirm Action With Password modal.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import withModal from './modal/withModal';
import { CONFIRM_MODAL_WITH_PASSWORD } from '../../constants/modals';
import { ConfirmDialogComp } from './ConfirmModal';
import Alert from './Alert';
import FormGroup from './FormGroup';
import Spinner from './Spinner';

class ConfirmWithPassword extends Component {
  static propTypes = {
    actionProps: PropTypes.shape({
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      confirmText: PropTypes.string,
      cancelText: PropTypes.string,
      onConfirm: PropTypes.func.isRequired,
      onCancel: PropTypes.func,
      confirmBtnStyle: PropTypes.string,
      showDoNotShowAgain: PropTypes.bool,
      passwordFieldLabel: PropTypes.string,
    }),
    user: PropTypes.shape({
      id: PropTypes.string,
      email: PropTypes.string,
    }),
    loading: PropTypes.bool,
    accountLogin: PropTypes.func.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    authenticated: PropTypes.bool,
  };

  state = {
    error: null,
    processing: false,
  };

  password = null;

  onConfirm = doNotShowAgain => {
    const {
      actionProps: { onConfirm },
      onRequestClose,
      accountLogin,
      user,
    } = this.props;

    const password = this.password.value;

    if (!password) {
      this.setState(() => ({ error: 'Password was not provided' }));

      return;
    }

    this.setState(
      () => ({ processing: true, error: '' }),
      async () => {
        try {
          await accountLogin(user.email_address, this.password.value);
          this.setState(() => ({ processing: false }));
          onConfirm(doNotShowAgain);
          onRequestClose();
        } catch (error) {
          this.setState(() => ({
            error:
              'Incorrect password. Please check your password and try again.',
            processing: false,
          }));
        }
      },
    );
  };

  onCancel = () => {
    const {
      actionProps: { onCancel },
      onRequestClose,
    } = this.props;

    onRequestClose();

    if (onCancel) {
      onCancel();
    }
  };

  render() {
    const { actionProps, loading, onRequestClose, authenticated } = this.props;
    const { error, processing } = this.state;
    const { passwordFieldLabel = 'Please provide your password to continue' } =
      actionProps;

    if (loading) {
      return <Spinner />;
    }

    if (!authenticated) {
      // Fallback
      return (
        <ConfirmDialogComp
          actionProps={actionProps}
          onRequestClose={onRequestClose}
        />
      );
    }

    return (
      <ConfirmDialogComp
        actionProps={{
          ...actionProps,
          // These two methods are to be handled by this component
          onConfirm: this.onConfirm,
          onCancel: this.onCancel,
        }}
      >
        {error && (
          <Alert type="danger" className="mt-2">
            {error}
          </Alert>
        )}
        <form
          onSubmit={event => {
            event.preventDefault();
            this.onConfirm();
          }}
        >
          <p className="text-dark text-sm mb-1">{passwordFieldLabel}</p>
          <FormGroup
            className="m-0"
            id="password"
            type="password"
            label={passwordFieldLabel}
            labelSrOnly
            name="password"
            required
            inputRef={ref => {
              this.password = ref;
            }}
          />
        </form>
        {processing && <span className="text-xs">Processing...</span>}
      </ConfirmDialogComp>
    );
  }
}

export { ConfirmWithPassword as ConfirmWithPasswordComp };

export default withModal(ConfirmWithPassword, {
  name: CONFIRM_MODAL_WITH_PASSWORD,
  size: 'sm',
  hideHeader: true,
  overlayClassName: 'modal-overlay-max',
});
